(function() {

    var buttons = document.querySelectorAll('.btn, .cta_button');

    for (var index = 0; index < buttons.length; index++) {
        buttons[index].addEventListener('click', OBJ002);
    }

    function OBJ002() {
        var OBJ002 = this;
        var value = OBJ002.innerText;

        dataLayer.push({
            "object": {
                "Id": "OBJ002",
                "name": "Click to Action - Button"
            },
            "event": "userAction",
            "cta": {
                "category": "button",
                "name": value
            }
        });
    }


    var links = document.querySelectorAll('a:not(.btn):not(.cta_button)');

    for (var index1 = 0; index1 < links.length; index1++) {
        links[index1].addEventListener('click', OBJ002_links);
    }

    function OBJ002_links() {
        var OBJ002 = this;
        var value = OBJ002.innerText;
        var attValue = OBJ002.getAttribute('obj002');


        if (value.length == 0 && attValue) {
            value = attValue;
        }


        dataLayer.push({
            "object": {
                "Id": "OBJ002",
                "name": "Click to Action - Link"
            },
            "event": "userAction",
            "cta": {
                "category": "link",
                "name": value
            }
        });
    }
})();
